<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <AdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <h4>Client Blogs</h4>
              <hr />

              <b-form class="p-2" @submit.prevent="updateBlogs">
                <div class="row" v-for="(Blog, index) in Blogs" :key="index">
                  <div class="col">
                    <div class="d-flex">
                      <input type="hidden" :value="Blog.OldBlogURL" />
                      <label
                        style="white-space: nowrap;"
                        for="blogURL"
                        class="p-1"
                        >Blog URL :</label
                      >
                      <b-form-textarea
                        v-model="Blog.NewBlogURL"
                        name=""
                        id="blogURL"
                        cols="30"
                        rows="6"
                        class="m-1"
                      ></b-form-textarea>
                    </div>
                  </div>
                  <div class="col">
                    <b-form-select
                      multiple
                      style="height: 90%; width:95%;"
                      class="m-1"
                      v-model="Blog.SelectedClients"
                    >
                      <option
                        v-for="client in getAuthorizedClients"
                        :key="client.clientId"
                        :value="+client.clientId"
                        >{{ client.clientName }}</option
                      >
                    </b-form-select>
                  </div>
                </div>
                <div
                  class="buttonContainer mt-2 p-2 d-flex justify-content-center align-items-center"
                >
                  <div class="d-inline">
                    <button
                      type="button"
                      class="btn btn-primary mr-2"
                      @click="addNewBlog"
                    >
                      Add a New Blog
                    </button>
                    <button type="submit" class=" btn btn-primary">
                      Update Client Blogs
                    </button>
                  </div>
                </div>
              </b-form>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";

export default {
  name: "ClientBlogs",
  data() {
    return {
      Blogs: [
        // {
        //   OldBlogURL: "",
        //   NewBlogURL: "",
        //   SelectedClients: [],
        // },
      ],
    };
  },
  components: {
    AdminSidebar,
    Header,
    Footer,
  },

  computed: {
    getAuthorizedClients() {
      return this.$store.getters["clientBlogs/getAuthorizedClients"];
    },
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "communicationClientBlogs",
        activeMenu: this.activeMenu ? this.activeMenu : "communication",
      });
    },
    addNewBlog() {
      this.Blogs = [
        ...this.Blogs,
        {
          OldBlogURL: "",
          NewBlogURL: "",
          SelectedClients: [],
        },
      ];
    },
    updateBlogs() {
      console.log(this.Blogs);

      let UpdatedBlogs = [];
      for (let blog of this.Blogs) {
        if (blog.OldBlogURL === "" && blog.NewBlogURL === "") {
          console.log("extra blog fields will get removed.");
        } else {
          if (blog.SelectedClients.length !== 0) {
            UpdatedBlogs.push({
              old_url: blog.OldBlogURL,
              new_url: blog.NewBlogURL,
              client_ids: blog.SelectedClients,
            });
          } else {
            alert("Select atleast one client from the clients dropdown.");
            return;
          }
        }
      }

      // console.log(UpdatedBlogs);

      this.$store
        .dispatch("clientBlogs/updateClientBlogs", UpdatedBlogs)
        .then(() => {
          this.$router.push({ name: "Home" });
        });
    },
    setData(dataArr) {
      if (dataArr === null) return;

      this.Blogs = [];

      for (let i = 0; i < dataArr.length; i++) {
        let url = dataArr[i].url;
        let selectedClients = [];
        for (let j = 0; j < dataArr[i].clients.length; j++) {
          let id = dataArr[i].clients[j].id;
          selectedClients.push(id);
        }

        this.Blogs.push({
          OldBlogURL: url,
          NewBlogURL: url,
          SelectedClients: selectedClients,
        });
      }
    },
  },

  created() {
    this.setActiveMenuItem();

    this.$store.dispatch("clientBlogs/fetchAuthorizedClients");

    this.$store.dispatch("clientBlogs/fetchClientBlogs").then((data) => {
      this.setData(data);
    });
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
